import Cookies from 'js-cookie';
import { makeStyles } from 'tss-react/mui';
import { useAppContext } from '../contexts/app';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useCallback, useState } from 'react';

const DISMISSED_COOKIE = 'signup_banner_dismissed';

const useStyles = makeStyles()((theme) => ({
  banner: {
    padding: theme.spacing(1, 2),
    backgroundColor: theme.palette.primary.background,
    borderBottom: `1px solid ${theme.palette.primary.light}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      textAlign: 'center',
    },
  },
  buttonWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  button: {
    whiteSpace: 'nowrap',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
  },
}));

const SignupBanner = () => {
  const { classes } = useStyles();
  const { isLoggedIn, login } = useAppContext();
  const [dismissed, setDismissed] = useState(false);

  const handleLogin = useCallback(() => {
    login();
  }, [login]);

  const handleDismiss = useCallback(() => {
    setDismissed(true);
    Cookies.set(DISMISSED_COOKIE, '1');
  }, []);

  if (isLoggedIn || dismissed) {
    return null;
  }

  return (
    <Box className={classes.banner} sx={{ position: 'relative' }}>
      <div>
        <strong>New to Everyday Rides?</strong>
        {' '}Sign up to get weekly emails about upcoming events and join groups!
      </div>
      <div className={classes.buttonWrapper}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleLogin}
          className={classes.button}
        >
          Sign Up
        </Button>
      </div>
      <IconButton
        size="small"
        aria-label="Dismiss"
        onClick={handleDismiss}
        className={classes.closeButton}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};

export default SignupBanner;
